import customHeaders, { getSpace } from '../../common/headers';
import add_icon from './img/add.svg';
import { useDataTable } from '../../common/hooks';
import { useState, useRef, useEffect } from 'react';
import { KonstantinMasterHttps } from './../../fetchUrls';
import {
  ButtonBasic,
  TableBox,
  DropDownSelector,
  RangeBox,
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import './FinanceByPeriod.scss';
import AddBalanceModal from '../../components/AddBalanceModal';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { periodWeek } from '../../common/constant';
import { msToLocalDate } from '../../common/constant';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { useResponseHandler } from '../../common/auth';

const options_period = [
  { label: 'По дням', value: 'День' },
  { label: 'По неделям', value: 'Неделя' },
  { label: 'По месяцам', value: 'Месяц' },
];

const FinanceByPeriod = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const [isModalBalance, setIsModalBalance] = useState(false);

  // Фильтры
  const filterConfig = [
    { key: 'type_operation', type: 'single' },
    { key: 'period', type: 'single' },
    { key: 'date_from', type: 'date' },
    { key: 'date_to', type: 'date' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState(options_period[0]);

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading } = setTableFuncs;

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.period) setSelectedPeriod(urlParams.period)
        if (urlParams.date_from) {
          setDate([
            new Date(parseInt(urlParams.date_from)),
            new Date(parseInt(urlParams.date_to)),
          ]);
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams]);

  useEffect(() => {
    updateURL({
      period: urlParams?.period || selectedPeriod,
      date_from: urlParams?.date_from || dateFrom,
      date_to: urlParams?.date_to || dateTo,
    })
  }, []);

  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!selectedPeriod?.value) return
    let sort;
    let filters;

    if (params) {
      [sort, filters] = params;
    }

    const [date_from, date_to] = date;
    const orderParam = sort?.[0]
      ? `&order_param=${sort?.[0]}&order_param_direction=${sort?.[1]}`
      : '';

    setLoading(true);
    let url = `${KonstantinMasterHttps}/finance/by-period/reports-by-period?period=${selectedPeriod?.value}${orderParam}`

    const body = JSON.stringify({
      date_from: msToLocalDate(date_from),
      date_to: msToLocalDate(date_to),
      filters,
      limit: paginatorRef.current?.limit,
      page: paginatorRef.current?.page,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) =>  setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  useEffect(() => {
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [date, isTableRequest]);

  return (
    <>
      {isModalBalance &&
        <AddBalanceModal
          setIsModalActive={(e) => setIsModalBalance(false)}
        />
      }

      <div className="finance-by-period">
        <div className="finance-by-period__header">
          <TitlePage
            title='По периодам'
          />

          <ButtonBasic
            green
            width="190px"
            icon={add_icon}
            text={'Пополнить баланс'}
            onClick={() => setIsModalBalance(true)}
          />
        </div>

        <div className="finance-by-period__table">
          <div className="finance-by-period__header-table">
            <DropDownSelector
              options_prop={options_period}
              state={selectedPeriod}
              setState={setSelectedPeriod}
              isClearable={false}
              onBlur={(e) => {
                updateURL({ period: selectedPeriod });
                setIsTableRequest(!isTableRequest)
              }}
              maxWidth='150px'
            />

            <RangeBox
              date={date}
              setDate={(e) => {
                const [newDateFrom, newDateTo] = e;
                updateURL({
                  date_from: newDateFrom,
                  date_to: newDateTo
                });
                setDate(e)
              }}
            />
          </div>

          <TableBox
            ref={paginatorRef}
            paginator={true}
            {...tableProps}
            fetchCallback={fetchTableData}
          />
        </div>
      </div>
    </>
  );
};

export { FinanceByPeriod };
